import { render, staticRenderFns } from "./modal-plant-detail.component.vue?vue&type=template&id=b28ec3fe&scoped=true&"
import script from "./modal-plant-detail.component.vue?vue&type=script&lang=js&"
export * from "./modal-plant-detail.component.vue?vue&type=script&lang=js&"
import style0 from "./modal-plant-detail.component.vue?vue&type=style&index=0&id=b28ec3fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28ec3fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ksaffer/Projects/Client/natorp-plant-database/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b28ec3fe')) {
      api.createRecord('b28ec3fe', component.options)
    } else {
      api.reload('b28ec3fe', component.options)
    }
    module.hot.accept("./modal-plant-detail.component.vue?vue&type=template&id=b28ec3fe&scoped=true&", function () {
      api.rerender('b28ec3fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "_src/js/components/modal-plant-detail.component.vue"
export default component.exports